import { Component, OnInit, ElementRef, Inject, ViewChild, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IBusStop, IBusStopResponse } from '../../busstops/busstops.interfaces';

import { StripHtmlPipe } from '../../pipes/stripHTMLpipe';
import { DatePipe } from '@angular/common';
import { BusStopService } from '../../services/busstops/busstops.service';

import * as L from 'leaflet';
import * as moment from 'moment';

@Component({
  selector: 'dialog-data',
  templateUrl: './dialog.component.busstops.html',
  styleUrls: ['./dialog.component.busstops.scss'],
  providers: [DatePipe, BusStopService]
})

export class DialogBusStop {
  private busStopModel: IBusStop = {
  'id': '',
  'name': '',
  'description': '',
  'lat': null,
  'long': null,
  'address': '',
  'city': '',
  'cp': '',
  'district': '',
  'direction': '',
  'type': '',
  'routes_served': null,
  'daily_passengers': null,
  'amenities': '',
  'installation': '',
  'last_inspection': '',
  'maintainded': '',
  'notes': ''
  };
  private id: string;
  public error: string = '';
  public showMap = false;
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editBusStopData: IBusStop;
  
  public parish: any[];
  public causeList: any[];
  public plateList: any[];
  public idList: any[];
    
  public userInfo: any = {};
  public filterStates(val: string) { }
  // Fallback: Grenada (país), coincidint amb el teu bbox original
  private readonly DEFAULT_LAT = 12.15;
  private readonly DEFAULT_LON = -61.65;
  private readonly DEFAULT_ZOOM = 10;
  private readonly MARKER_ZOOM = 15;

  private map: L.Map | undefined;
  private marker: L.Marker | undefined;

  constructor(private sanitizer: DomSanitizer, private datePipe: DatePipe, public dialogRef: MatDialogRef<DialogBusStop>, @Inject(MAT_DIALOG_DATA) public data: any, public busStopService: BusStopService){ 
   this.editBusStopData =  data.dades;
  
   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
   this.userInfo = data.user;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editBusStopData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  afegir(event){
    if(event){
      this.id = event.value;
    }
  }

  setAny(event, picker) {
    this.data.setFullYear(event.year());
    picker.close();
  }

  ngOnInit(){ }


  ngAfterViewInit(): void {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // si editAccidentData es carrega/canvia després del ngAfterViewInit
    if (this.map && changes['editAccidentData']) {
      this.updateMap();
    }
  }

  private initMap(): void {
    // Fix de les icones per defecte de Leaflet amb Angular CLI/webpack
    delete (L.Icon.Default.prototype as any)._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
      iconUrl: 'assets/leaflet/marker-icon.png',
      shadowUrl: 'assets/leaflet/marker-shadow.png',
    });
    this.map = L.map('map', {
      scrollWheelZoom: false
    }).setView([this.DEFAULT_LAT, this.DEFAULT_LON], this.DEFAULT_ZOOM);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '© OpenStreetMap'
    }).addTo(this.map);

    this.updateMap();
  }

  private updateMap(): void {
    const lat = this.toValidCoord(this.editBusStopData?.lat);
    const lon = this.toValidCoord(this.editBusStopData?.long);


    if (!isNaN(lat) && !isNaN(lon)) {
      this.map!.setView([lat, lon], this.MARKER_ZOOM);

      if (this.marker) {
        this.marker.setLatLng([lat, lon]);
      } else {
        this.marker = L.marker([lat, lon]).addTo(this.map!);
      }
    } else {
      // sense coordenades vàlides: torna a la vista per defecte, sense marcador
      this.map!.setView([this.DEFAULT_LAT, this.DEFAULT_LON], this.DEFAULT_ZOOM);
      if (this.marker) {
        this.map!.removeLayer(this.marker);
        this.marker = undefined;
      }
    }
  }

  private toValidCoord(value: string | null | undefined): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const num = Number(value);
    return isNaN(num) ? null : num;
  }

}
